import { render, staticRenderFns } from "./AIcopyDrawer.vue?vue&type=template&id=298cce3c&scoped=true"
import script from "./AIcopyDrawer.vue?vue&type=script&lang=js"
export * from "./AIcopyDrawer.vue?vue&type=script&lang=js"
import style0 from "./AIcopyDrawer.vue?vue&type=style&index=0&id=298cce3c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298cce3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('298cce3c')) {
      api.createRecord('298cce3c', component.options)
    } else {
      api.reload('298cce3c', component.options)
    }
    module.hot.accept("./AIcopyDrawer.vue?vue&type=template&id=298cce3c&scoped=true", function () {
      api.rerender('298cce3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Operation/OperationMalfunction/AIcopyDrawer.vue"
export default component.exports